import * as React from 'react'
import Alert from '@mui/material/Alert'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import useTheme from '@mui/material/styles/useTheme'
import { InfoIcon } from '../atoms/Icon/InfoIcon'

interface Props {
  title: string
  subTitle: string
  icon?: JSX.Element
}

export const RequirementsHeader: React.FC<Props> = (props: Props) => {
  const { subTitle } = props

  const theme = useTheme()

  return (
    <Stack spacing={theme.spacing(2)}>
      {/* <Box display="flex">
        {icon}
        <Typography variant="h6" ml={icon ? 2 : '0px'}>
          {title}
        </Typography>
      </Box> */}
      <div style={{ textAlign: 'left' }}>
        <Alert severity="info" icon={<InfoIcon></InfoIcon>}>
          {subTitle}
        </Alert>
      </div>
      <Divider />
    </Stack>
  )
}
